import { AppHeader } from '@/components/AppHeader'
import { PatientActionsCta } from '@/components/HomePage/PatientActionsCta'
import { PeakSmileMarquee } from '@/components/HomePage/PeakSmileMarquee'
import { ReferralImageCTA } from '@/components/HomePage/ReferralImageCTA'
import ProtectedPage from '@/components/ProtectedPage'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'

export default function HomeScreen() {
	return (
		<ProtectedPage>
			<Screen preset="fixed" className="flex h-full w-full">
				<AppHeader />
				<VStack className="flex h-auto flex-1 w-full">
					<PatientActionsCta />
					<PeakSmileMarquee />
					<ReferralImageCTA />
				</VStack>
			</Screen>
		</ProtectedPage>
	)
}
